import React from "react";
import { formatarData } from "../../../../components/Formatters/DateTime";

const PedidosVirtuaisCard = ({ pedidosVirtuais }) => (
  <div className="col-lg-12">
    <div className="card shadow mb-1">
      <div className="card-header">
        <b>Pedidos Virtuais Em Andamento (Não Finalizados)</b>
      </div>
      <div className="card-body">
        <center>
          <table className="table table-striped table-bordered" width="100%">
            <thead>
              <tr>
                <th>
                  <center>Tipo</center>
                </th>
                <th>
                  <center>Protocolo</center>
                </th>
                <th>
                  <center>Data Pedido</center>
                </th>
                <th>
                  <center>Situação</center>
                </th>
                <th>
                  <center>Setor</center>
                </th>
              </tr>
            </thead>
            <tbody>
              {pedidosVirtuais?.map((pedido) => (
                <tr>
                  <td>{pedido.tipoProcesso}</td>
                  <td>
                    <center>{pedido.numeroProcesso}</center>
                  </td>
                  <td>
                    <center>{formatarData(pedido.dataPedido, "dd/MM/yyyy")}</center>
                  </td>
                  <td>
                    <center>{pedido.situacaoProcesso}</center>
                  </td>
                  <td>
                    <center>{pedido.setor}</center>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </center>
      </div>
    </div>
  </div>
);

export default PedidosVirtuaisCard;
